import axios from '../axios'

// 全コース横断の教材一覧（admin・教材管理）
const getAllMaterialsApi = async () => {
  return await axios.get('api/lms/materials')
}

export default getAllMaterialsApi
